import * as React from 'react';
import defaultAvatar from '@images/default.png';
import { PairRankItem } from '@/fetch.ts';
const PkItem: React.FC<PairRankItem> = props => (
  <div className='pkitem'>
    <div className='left'>
      <div
        className='avatarcover'
        onClick={(): void => {
          window.open('https://m.huya.com/' + props.tLeftItem.tJump.iRoomId, '_blank');
        }}
      >
        <img className='avatar'
          src={props.tLeftItem.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
          title={props.tLeftItem.sNickName}/>
        {
          props.tLeftItem.lScore > props.tRightItem.lScore &&
            <i className='crown'></i>
        }
        {
          props.tLeftItem.tJump.bIsLive &&
            <i className='living'></i>
        }
      </div>
      <div className='message'>
        <h4
          onClick={(): void => {
            window.open('https://m.huya.com/' + props.tLeftItem.tJump.iRoomId, '_blank');
          }}
        >{props.tLeftItem.sNickName}</h4>
        <div><span>战力&nbsp;</span><h5>{props.tLeftItem.lScore}</h5></div>
      </div>
    </div>
    <i></i>
    <div className='right'>
      <div
        className='avatarcover'
        onClick={(): void => {
          window.open('https://m.huya.com/' + props.tRightItem.tJump.iRoomId, '_blank');
        }}
      >
        <img className='avatar'
          src={props.tRightItem.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
          title={props.tRightItem.sNickName}/>
        {
          props.tRightItem.lScore > props.tLeftItem.lScore &&
            <i className='crown'></i>
        }
        {
          props.tRightItem.tJump.bIsLive &&
            <i className='living'></i>
        }
      </div>
      <div className='message'>
        <h4
          onClick={(): void => {
            window.open('https://m.huya.com/' + props.tRightItem.tJump.iRoomId, '_blank');
          }}
        >{props.tRightItem.sNickName}</h4>
        <div><span>战力&nbsp;</span><h5>{props.tRightItem.lScore}</h5></div>
      </div>
    </div>
  </div>
)

export default PkItem;